import { render, staticRenderFns } from "./informations.vue?vue&type=template&id=a4417bb2"
import script from "./informations.vue?vue&type=script&lang=ts"
export * from "./informations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports